import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULTS = {
  hero_headline: "Simplify leasehold cases for your clients.",
  hero_subheadline:
    "A visual case management platform built for UK conveyancing firms. Reduce emails. Increase clarity. Improve client confidence.",
  pricing_headline: "Simple pricing for conveyancing firms.",
  pricing_subheadline: "No per-user fees. No setup costs. Cancel anytime.",
  plan_starter_price: "49",
  plan_pro_price: "99",
  plan_firm_price: "149",
};

export function useSiteSettings() {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/site/settings`)
      .then((r) => {
        if (!cancelled && r.data) setSettings({ ...DEFAULTS, ...r.data });
      })
      .catch(() => {
        // Keep defaults on error — public pages must always render
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return settings;
}
